export const imageStatus = {
  pending: "pending",
  invalid: "invalid",
  valid: "valid",
};